import { Link } from "@quintype/components";
import React from "react";
import "./story-card20.m.css";
import get from "lodash.get";
import Headline from "../../atoms/headline";

function StoryCard20({ story, alternativeHeadline, clamp = 3 }) {
  const isClosed = get(story, ["metadata", "is-closed"], false);
  const { slug, headline } = story;
  const title = alternativeHeadline ? getHeadline(story) : headline;
  const closeLiveBlog = story?.["first-published-at"] < 1688185800000;
  const isLive = story["story-template"] === "live-blog" && !isClosed && !closeLiveBlog;

  return (
    <div id="story-card-20">
      <Link href={`/${slug}`}>
        <span styleName="story-card-20-summary" className={`summary line-clamp-${clamp}`}>
          {!isLive && <span styleName="custom-bullet"></span>}
          <Headline text={title} headerType={2} headerLevel={2} story={story} />
        </span>
      </Link>
    </div>
  );
}

export default StoryCard20;
